import { useContext } from "react";
import { AuthContext } from "../context";
import HttpService from "./http.service";

export const useAxiosInterceptors = () => {
  const authContext = useContext(AuthContext);

  const setupInterceptors = (onUnauthenticated) => {
    const onRequestSuccess = async (config) => config;
    const onRequestFail = (error) => Promise.reject(error);

    HttpService.addRequestInterceptor(onRequestSuccess, onRequestFail);

    const onResponseSuccess = async (response) => response;

    const onResponseFail = (error) => {
      const status = error.status || error.response?.status;
      if (status === 403 || status === 401) {
        setTimeout(() => {
          authContext.logout();
        }, 1000);
      }
      return Promise.reject(error);
    };

    HttpService.addResponseInterceptor(onResponseSuccess, onResponseFail);
  };

  return setupInterceptors;
};
